import React, { Fragment } from "react";
import Select from "react-select";
import loadImage from "blueimp-load-image";
import Fade from "@material-ui/core/Fade";
import Firebase from "../../../firebasehelper";
import CircularProgress from "@material-ui/core/CircularProgress";
import MonthWeekSelect from "../../../components/MonthWeekSelect";
import ImageUpload from "../../../components/ContentUpload/ImageUpload";
import VideoUpload from "../../../components/ContentUpload/VideoUpload";
import YoutubeInput from "../../../components/ContentUpload/YoutubeInput";
import RadioItem from "../../../components/RadioItem";
import { TerritoryOptions } from "../../../Constants/retailer";
import { ContentTypes } from "../../../Constants/selections";
import "./index.css";
import {
  GIF_UPLOAD,
  VIDEO_UPLOAD,
  IMAGE_UPLOAD,
  YOUTUBE_URL,
} from "../../../Constants/types";
import {
  UPLOADING_VIDEO,
  UPLOADING_IMAGE,
  UPLOADING_GIF,
} from "../../../Constants/string";

const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 250,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};

class AddHotTopicModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      description: "",
      error_msg: "",
      img_content: "",
      territory: TerritoryOptions[0],
      tag: "",
      starting_monday: null,
      mediaType: null,
      loading_script: "",
      loading: false,
      toMembers: true,
      toReferrals: true,
    };
  }
  componentDidMount() {
    console.log("this.props", this.props);
    const { territory = TerritoryOptions[0] } = this.props;
    this.setState({ territory });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.territory !== this.props.territory) {
      this.setState({ territory: this.props.territory });
    }
  }
  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };
  handleSelectContentType = (type) => {
    this.setState({ mediaType: type });
  };
  handleSetMediaURL = (url) => {
    this.setState({ mediaUrl: url });
  };
  selectedFile = (event) => {
    let _this = this;
    event.stopPropagation();
    event.preventDefault();
    const content = event.target.files[0];
    loadImage.parseMetaData(content, function (data) {
      //default image orientation
      var orientation = 0;
      if (data.exif) {
        orientation = data.exif.get("Orientation");
      }
      loadImage(
        content,
        function (canvas) {
          var base64data = canvas.toDataURL("image/png");
          var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
          _this.setState({ content: img_src });
          let img_content = "data:image/jpeg;base64," + img_src;
          _this.setState({ img_content });
        },
        {
          canvas: true,
          orientation: orientation,
        }
      );
    });
  };
  checkValidation = () => {
    const { title, mediaType, mediaUrl, description, starting_monday, tag } =
      this.state;
    const title_validation = title ? true : false;
    const media_content_validation = mediaType && mediaUrl ? true : false;
    const description_validation = description ? true : false;
    const tag_validation = tag ? true : false;
    const week_validation = starting_monday ? true : false;
    const validation =
      title_validation &&
      media_content_validation &&
      description_validation &&
      week_validation;
    return validation;
  };
  createHotTopic = () => {
    const {
      title,
      mediaType,
      mediaUrl,
      description,
      starting_monday,
      toMembers,
      toReferrals,
    } = this.state;
    const { createHotTopic } = this.props;

    let payload = {
      title,
      media_url: mediaUrl,
      media_type: mediaType.value,
      description,
      starting_monday,
      toMembers,
      toReferrals,
    };
    createHotTopic(payload);
  };
  setWeek = (starting_monday) => {
    this.setState({ starting_monday });
  };
  uploadContent = (contentType) => async (mediaContent) => {
    const uploadFolder = "hot-topics/";
    const title = new Date().getTime().toString();
    if (contentType === GIF_UPLOAD) {
      this.setState({ loading: true, loading_script: UPLOADING_GIF });
      let gif_url = await Firebase.uploadGif(
        mediaContent,
        title,
        uploadFolder + "/gifs"
      );
      this.setState({ loading: false });
      this.handleSetMediaURL(gif_url);
    } else if (contentType === IMAGE_UPLOAD) {
      this.setState({ loading: true, loading_script: UPLOADING_IMAGE });
      let img_url = await Firebase.uploadImage(
        mediaContent,
        title,
        uploadFolder + "/images"
      );
      this.setState({ loading: false });
      this.handleSetMediaURL(img_url);
    } else if (contentType === VIDEO_UPLOAD) {
      const uploadTask = Firebase.uploadVideo(
        mediaContent,
        uploadFolder + "/videos"
      );
      this.setState({ loading: true, loading_script: UPLOADING_VIDEO });
      uploadTask.on(
        "state_changed",
        this.handleUploadProgress,
        this.handleUploadError,
        () => {
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            this.setState({ loading: false, loading_script: "" });
            this.handleSetMediaURL(downloadURL);
          });
        }
      );
    } else if (contentType === YOUTUBE_URL) {
      this.handleSetMediaURL(mediaContent);
    }
  };
  handleUploadProgress = (snapshot) => {
    var progress = (
      (snapshot.bytesTransferred / snapshot.totalBytes) *
      100
    ).toFixed(0);
    const loading_script = UPLOADING_VIDEO + " " + progress + "%";
    this.setState({ loading_script });
  };

  handleUploadError = (error) => {
    this.setState({ loading: false, loading_script: "" });
  };
  render() {
    const {
      title,
      mediaType,
      loading,
      loading_script,
      description,
      toMembers,
      toReferrals,
      tag,
    } = this.state;

    const { hex, white } = this.props;

    return (
      <div
        className="modal fade add-hotTopic-dialog"
        id="add_hotTopic_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content add-hotTopic-content">
            <div className="modal-header">
              <h5 className="modal-title">Add a HotTopic</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1 add-hotTopic-dialog-body">
              <p className="add-hotTopic-title">Title</p>
              <input
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("title")}
                value={title}
              />
              <p className="add-hotTopic-title">Content Type</p>
              <div className="col-10 mb-2">
                <Select
                  value={mediaType}
                  onChange={this.handleSelectContentType}
                  options={ContentTypes}
                  isSearchable={false}
                ></Select>
              </div>
              {mediaType && (
                <div className="col-div mb-2">
                  {mediaType.value === YOUTUBE_URL && (
                    <YoutubeInput
                      onChangeContent={this.uploadContent(YOUTUBE_URL)}
                    />
                  )}
                  {mediaType.value === IMAGE_UPLOAD && (
                    <ImageUpload
                      onChangeContent={this.uploadContent(IMAGE_UPLOAD)}
                    />
                  )}
                  {mediaType.value === GIF_UPLOAD && (
                    <ImageUpload
                      isGif={true}
                      onChangeContent={this.uploadContent(GIF_UPLOAD)}
                    />
                  )}
                  {mediaType.value === VIDEO_UPLOAD && (
                    <VideoUpload
                      onChangeContent={this.uploadContent(VIDEO_UPLOAD)}
                    />
                  )}
                </div>
              )}
              {/* <p className="add-hotTopic-title">
                Image
              </p>
              <button
                className="btn btn-green"
                onClick={()=>{this.upload.click()}}
              >
                  Select Image
              </button>
              <input
                  type="file"
                  id="image"
                  name="image"
                  accept="image/*"
                  ref={(ref) => this.upload = ref}
                  style={{display: 'none'}}
                  onChange={this.selectedFile}
              />
              {img_content&&<div className="image-div" style={{backgroundImage:`url(${img_content})`}}>
                </div>} */}
              <Fade
                in={loading}
                style={{
                  transitionDelay: loading ? "800ms" : "0ms",
                }}
                unmountOnExit
              >
                <Fragment>
                  <p>{loading_script}</p>
                  <CircularProgress />
                </Fragment>
              </Fade>
              <p className="add-hotTopic-title">Description</p>
              <textarea
                maxLength="280"
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("description")}
                value={description}
              />
              <p className="bottom-small-text">Max characters: 280</p>

              <p className="add-hotTopic-title">Tag</p>
              <input
                className="form-control form-control-md form-control-alt"
                onChange={this.handleInputChange("tag")}
                placeholder="@xxx"
                value={tag}
              />
              <p className="add-hotTopic-title">Select Week</p>
              <MonthWeekSelect onSetWeek={this.setWeek} />
              <div className="user-access-categories">
                <p>Post to user access categories</p>
                <RadioItem
                  menuName="Members"
                  checked={toMembers}
                  onYes={() => {
                    this.setState({ toMembers: true });
                  }}
                  onNo={() => {
                    this.setState({ toMembers: false });
                  }}
                />
                <RadioItem
                  menuName="Prospect"
                  checked={toReferrals}
                  onYes={() => {
                    this.setState({ toReferrals: true });
                  }}
                  onNo={() => {
                    this.setState({ toReferrals: false });
                  }}
                />
              </div>
              <div className="add-hotTopic-footer">
                <button
                  className="btn btn-brand-hex btn-white"
                  style={{
                    "--hover-text-color": white ? "white" : "black",
                    "--hover-color": hex,
                    backgroundColor: "white",
                    color: "black",
                  }}
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  className="btn btn-green"
                  onClick={this.createHotTopic}
                  disabled={!this.checkValidation()}
                  data-dismiss="modal"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddHotTopicModal;



// WEBPACK FOOTER //
// ./src/screens/HotTopic/AddHotTopicModal/index.js